import { LeadType } from '@/lib/entities/lead/model/lead-type';

import { Button } from '@/lib/shared/components/Buttons';
import { modal, FeedBackModalNew } from '@/lib/shared/components/Modal';
import { H1, P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './TopBlockManagement.module.scss';

import { landingsKeys } from '../TitleBlockFade/constants';

type TopBlockManagementProps = {
  title?: string;
  description?: string;
  buttonLabel?: string;
  styleType?: 'management' | 'rent';
  imageName?: string;
  keyPrefix?: string;
  leadType?: LeadType;
  h1?: string | null;
};

export const TopBlockManagement = ({
  title = 'topBlockTitle',
  description = 'topBlockText',
  buttonLabel = 'topBlockButton',
  styleType = 'management',
  imageName = 'management/topBlock',
  keyPrefix = 'managementPage',
  leadType = 'PROPERTY_MANAGEMENT',
  h1,
}: TopBlockManagementProps) => {
  const { t } = useTranslation('index', { keyPrefix: keyPrefix });

  const toCallModal = () => {
    const keys = landingsKeys[styleType];
    modal.open(
      <FeedBackModalNew
        {...keys}
        eventName={styleType === 'rent' ? ['rent'] : ['others']}
        buttonLabel="orderACall"
        leadType={leadType}
        sourceForm="request-call"
        agreementText="agreementOrderACall"
        comment="Запрос персональной подборки по аренде"
        messengerText={styleType === 'rent' ? 'viaMessenger' : 'inMessengers'}
      />,
      {
        isFeedBackNew: true,
      }
    );
  };
  return (
    <div className={cn(styles.topBlock, styles.container)}>
      <div
        className={cn(
          styles.topBlock__mainInfo,
          styleType === 'rent' && styles['topBlock__mainInfo--rent']
        )}
      >
        <H1 className={styles.topBlock__title}>{h1 || t(title)}</H1>
        <P3
          className={cn(
            styles.topBlock__description,
            styleType === 'rent' && styles['topBlock__description--rent']
          )}
        >
          {t(description)}
        </P3>
        <Button
          className={styles.topBlock__button}
          as={'button'}
          label={t(buttonLabel)}
          theme={'dark'}
          size={'lg'}
          onClick={toCallModal}
        />
        <Image
          src={`/images/${imageName}-mob.webp`}
          className={cn(
            styles.topBlock__imageMobile,
            styleType === 'rent' && styles['topBlock__imageMobile--rent']
          )}
          alt={''}
          loader={({ src }) => src + ' '}
          width={343}
          height={283}
          sizes="100vw"
        />
        <Image
          src={`/images/${imageName}.webp`}
          className={cn(
            styles.topBlock__imageDesctop,
            styleType === 'rent' && styles['topBlock__imageDesctop--rent']
          )}
          alt={''}
          loader={({ src }) => src + ' '}
          width={700}
          height={469}
          sizes="100vw"
        />
        {styleType === 'management' && (
          <Image
            src={'/images/management/cloudCircle.webp'}
            className={styles.topBlock__cloudCircle}
            alt={''}
            loader={({ src }) => src + ' '}
            width={68}
            height={68}
            sizes="100vw"
          />
        )}
      </div>
      <Button
        className={styles['topBlock__button--mobile']}
        as={'button'}
        label={t(buttonLabel)}
        theme={'dark'}
        size={'lg'}
        onClick={toCallModal}
      />
    </div>
  );
};
